import { some } from "../fable-library.3.7.20/Option.js";
import { get_UTF8 } from "../fable-library.3.7.20/Encoding.js";
import { Slice$1__get_Data, Slice$1__get_Mark } from "./Mark.fs.js";
import { fromInteger, op_Division, toNumber, compare, op_BitwiseAnd, op_RightShift, toInt, fromBits, equals } from "../fable-library.3.7.20/Long.js";
import { substring, printf, toFail } from "../fable-library.3.7.20/String.js";
import { class_type } from "../fable-library.3.7.20/Reflection.js";
import { fastStructuralHash } from "../fable-library.3.7.20/Util.js";
import { utcNow, add, addYears, addMonths, addDays, addHours, addMinutes, addSeconds, addMilliseconds, create, fromTicks, op_Subtraction, op_Addition, millisecond, second as second_2, minute as minute_2, hour as hour_2, day as day_2, month as month_2, year as year_2, getTicks, toString } from "../fable-library.3.7.20/Date.js";
import { toUniversalTime, fromDate } from "../fable-library.3.7.20/DateOffset.js";

function Internal_parse$0027(ctor, readYear, s, start, a, b, c) {
    const matchValue = readYear(s, start + a) | 0;
    if (matchValue === -1) {
        return void 0;
    }
    else {
        let matchValue_2;
        const s_1 = s;
        const i = (start + b) | 0;
        let matchValue_1;
        const s_2 = s_1;
        const i_1 = i | 0;
        if (i_1 >= s_2.length) {
            matchValue_1 = -1;
        }
        else {
            const c_1 = s_2[i_1];
            matchValue_1 = (((c_1 > "9") ? true : (c_1 < "0")) ? -1 : (c_1.charCodeAt(0) - 48));
        }
        if (matchValue_1 === -1) {
            matchValue_2 = -1;
        }
        else {
            let matchValue_1_1;
            const s_3 = s_1;
            const i_2 = (i + 1) | 0;
            if (i_2 >= s_3.length) {
                matchValue_1_1 = -1;
            }
            else {
                const c_2 = s_3[i_2];
                matchValue_1_1 = (((c_2 > "9") ? true : (c_2 < "0")) ? -1 : (c_2.charCodeAt(0) - 48));
            }
            matchValue_2 = ((matchValue_1_1 === -1) ? -1 : ((matchValue_1 * 10) + matchValue_1_1));
        }
        if (matchValue_2 === -1) {
            return void 0;
        }
        else {
            let matchValue_4;
            const s_4 = s;
            const i_3 = (start + c) | 0;
            let matchValue_3;
            const s_5 = s_4;
            const i_4 = i_3 | 0;
            if (i_4 >= s_5.length) {
                matchValue_3 = -1;
            }
            else {
                const c_3 = s_5[i_4];
                matchValue_3 = (((c_3 > "9") ? true : (c_3 < "0")) ? -1 : (c_3.charCodeAt(0) - 48));
            }
            if (matchValue_3 === -1) {
                matchValue_4 = -1;
            }
            else {
                let matchValue_1_2;
                const s_6 = s_4;
                const i_5 = (i_3 + 1) | 0;
                if (i_5 >= s_6.length) {
                    matchValue_1_2 = -1;
                }
                else {
                    const c_4 = s_6[i_5];
                    matchValue_1_2 = (((c_4 > "9") ? true : (c_4 < "0")) ? -1 : (c_4.charCodeAt(0) - 48));
                }
                matchValue_4 = ((matchValue_1_2 === -1) ? -1 : ((matchValue_3 * 10) + matchValue_1_2));
            }
            if (matchValue_4 === -1) {
                return void 0;
            }
            else {
                return ctor(matchValue, matchValue_2, matchValue_4);
            }
        }
    }
}

function Internal_parseDate_yyyy(ctor, s, start, y, m, d) {
    return Internal_parse$0027((yy, mm, dd) => some(ctor(yy, mm, dd)), (s_1, i) => {
        const s_2 = s_1;
        const i_1 = i | 0;
        let matchValue;
        const s_3 = s_2;
        const i_2 = i_1 | 0;
        if (i_2 >= s_3.length) {
            matchValue = -1;
        }
        else {
            const c = s_3[i_2];
            matchValue = (((c > "9") ? true : (c < "0")) ? -1 : (c.charCodeAt(0) - 48));
        }
        if (matchValue === -1) {
            return -1;
        }
        else {
            let matchValue_1;
            const s_4 = s_2;
            const i_3 = (i_1 + 1) | 0;
            if (i_3 >= s_4.length) {
                matchValue_1 = -1;
            }
            else {
                const c_1 = s_4[i_3];
                matchValue_1 = (((c_1 > "9") ? true : (c_1 < "0")) ? -1 : (c_1.charCodeAt(0) - 48));
            }
            if (matchValue_1 === -1) {
                return -1;
            }
            else {
                let matchValue_2;
                const s_5 = s_2;
                const i_4 = (i_1 + 2) | 0;
                if (i_4 >= s_5.length) {
                    matchValue_2 = -1;
                }
                else {
                    const c_2 = s_5[i_4];
                    matchValue_2 = (((c_2 > "9") ? true : (c_2 < "0")) ? -1 : (c_2.charCodeAt(0) - 48));
                }
                if (matchValue_2 === -1) {
                    return -1;
                }
                else {
                    let matchValue_3;
                    const s_6 = s_2;
                    const i_5 = (i_1 + 3) | 0;
                    if (i_5 >= s_6.length) {
                        matchValue_3 = -1;
                    }
                    else {
                        const c_3 = s_6[i_5];
                        matchValue_3 = (((c_3 > "9") ? true : (c_3 < "0")) ? -1 : (c_3.charCodeAt(0) - 48));
                    }
                    return ((matchValue_3 === -1) ? -1 : ((((matchValue * 1000) + (matchValue_1 * 100)) + (matchValue_2 * 10)) + matchValue_3)) | 0;
                }
            }
        }
    }, s, start, y, m, d);
}

function Internal_parseDate_yy(ctor, s, start, y, m, d) {
    return Internal_parse$0027((yy, mm, dd) => some(ctor(yy, mm, dd)), (s_1, i) => {
        const s_2 = s_1;
        const i_1 = i | 0;
        let matchValue;
        const s_3 = s_2;
        const i_2 = i_1 | 0;
        if (i_2 >= s_3.length) {
            matchValue = -1;
        }
        else {
            const c = s_3[i_2];
            matchValue = (((c > "9") ? true : (c < "0")) ? -1 : (c.charCodeAt(0) - 48));
        }
        if (matchValue === -1) {
            return -1;
        }
        else {
            let matchValue_1;
            const s_4 = s_2;
            const i_3 = (i_1 + 1) | 0;
            if (i_3 >= s_4.length) {
                matchValue_1 = -1;
            }
            else {
                const c_1 = s_4[i_3];
                matchValue_1 = (((c_1 > "9") ? true : (c_1 < "0")) ? -1 : (c_1.charCodeAt(0) - 48));
            }
            return ((matchValue_1 === -1) ? -1 : ((matchValue * 10) + matchValue_1)) | 0;
        }
    }, s, start, y, m, d);
}

function Internal_parseDateTime_yyyy(ctor, s, start, m, d, h, mi, se) {
    return Internal_parse$0027((y, m_1, d_1) => Internal_parse$0027((hh, mm, ss) => some(ctor(y, m_1, d_1, hh, mm, ss)), (s_1, i) => {
        const s_2 = s_1;
        const i_1 = i | 0;
        let matchValue;
        const s_3 = s_2;
        const i_2 = i_1 | 0;
        if (i_2 >= s_3.length) {
            matchValue = -1;
        }
        else {
            const c = s_3[i_2];
            matchValue = (((c > "9") ? true : (c < "0")) ? -1 : (c.charCodeAt(0) - 48));
        }
        if (matchValue === -1) {
            return -1;
        }
        else {
            let matchValue_1;
            const s_4 = s_2;
            const i_3 = (i_1 + 1) | 0;
            if (i_3 >= s_4.length) {
                matchValue_1 = -1;
            }
            else {
                const c_1 = s_4[i_3];
                matchValue_1 = (((c_1 > "9") ? true : (c_1 < "0")) ? -1 : (c_1.charCodeAt(0) - 48));
            }
            return ((matchValue_1 === -1) ? -1 : ((matchValue * 10) + matchValue_1)) | 0;
        }
    }, s, start, h, mi, se), (s_5, i_4) => {
        const s_6 = s_5;
        const i_5 = i_4 | 0;
        let matchValue_2;
        const s_7 = s_6;
        const i_6 = i_5 | 0;
        if (i_6 >= s_7.length) {
            matchValue_2 = -1;
        }
        else {
            const c_2 = s_7[i_6];
            matchValue_2 = (((c_2 > "9") ? true : (c_2 < "0")) ? -1 : (c_2.charCodeAt(0) - 48));
        }
        if (matchValue_2 === -1) {
            return -1;
        }
        else {
            let matchValue_1_1;
            const s_8 = s_6;
            const i_7 = (i_5 + 1) | 0;
            if (i_7 >= s_8.length) {
                matchValue_1_1 = -1;
            }
            else {
                const c_3 = s_8[i_7];
                matchValue_1_1 = (((c_3 > "9") ? true : (c_3 < "0")) ? -1 : (c_3.charCodeAt(0) - 48));
            }
            if (matchValue_1_1 === -1) {
                return -1;
            }
            else {
                let matchValue_2_1;
                const s_9 = s_6;
                const i_8 = (i_5 + 2) | 0;
                if (i_8 >= s_9.length) {
                    matchValue_2_1 = -1;
                }
                else {
                    const c_4 = s_9[i_8];
                    matchValue_2_1 = (((c_4 > "9") ? true : (c_4 < "0")) ? -1 : (c_4.charCodeAt(0) - 48));
                }
                if (matchValue_2_1 === -1) {
                    return -1;
                }
                else {
                    let matchValue_3;
                    const s_10 = s_6;
                    const i_9 = (i_5 + 3) | 0;
                    if (i_9 >= s_10.length) {
                        matchValue_3 = -1;
                    }
                    else {
                        const c_5 = s_10[i_9];
                        matchValue_3 = (((c_5 > "9") ? true : (c_5 < "0")) ? -1 : (c_5.charCodeAt(0) - 48));
                    }
                    return ((matchValue_3 === -1) ? -1 : ((((matchValue_2 * 1000) + (matchValue_1_1 * 100)) + (matchValue_2_1 * 10)) + matchValue_3)) | 0;
                }
            }
        }
    }, s, start, 0, m, d);
}

function Internal_parseDateTime_yy(ctor, s, start, m, d, h, mi, se) {
    return Internal_parse$0027((y, m_1, d_1) => Internal_parse$0027((hh, mm, ss) => some(ctor(y, m_1, d_1, hh, mm, ss)), (s_1, i) => {
        const s_2 = s_1;
        const i_1 = i | 0;
        let matchValue;
        const s_3 = s_2;
        const i_2 = i_1 | 0;
        if (i_2 >= s_3.length) {
            matchValue = -1;
        }
        else {
            const c = s_3[i_2];
            matchValue = (((c > "9") ? true : (c < "0")) ? -1 : (c.charCodeAt(0) - 48));
        }
        if (matchValue === -1) {
            return -1;
        }
        else {
            let matchValue_1;
            const s_4 = s_2;
            const i_3 = (i_1 + 1) | 0;
            if (i_3 >= s_4.length) {
                matchValue_1 = -1;
            }
            else {
                const c_1 = s_4[i_3];
                matchValue_1 = (((c_1 > "9") ? true : (c_1 < "0")) ? -1 : (c_1.charCodeAt(0) - 48));
            }
            return ((matchValue_1 === -1) ? -1 : ((matchValue * 10) + matchValue_1)) | 0;
        }
    }, s, start, h, mi, se), (s_5, i_4) => {
        const s_6 = s_5;
        const i_5 = i_4 | 0;
        let matchValue_2;
        const s_7 = s_6;
        const i_6 = i_5 | 0;
        if (i_6 >= s_7.length) {
            matchValue_2 = -1;
        }
        else {
            const c_2 = s_7[i_6];
            matchValue_2 = (((c_2 > "9") ? true : (c_2 < "0")) ? -1 : (c_2.charCodeAt(0) - 48));
        }
        if (matchValue_2 === -1) {
            return -1;
        }
        else {
            let matchValue_1_1;
            const s_8 = s_6;
            const i_7 = (i_5 + 1) | 0;
            if (i_7 >= s_8.length) {
                matchValue_1_1 = -1;
            }
            else {
                const c_3 = s_8[i_7];
                matchValue_1_1 = (((c_3 > "9") ? true : (c_3 < "0")) ? -1 : (c_3.charCodeAt(0) - 48));
            }
            if (matchValue_1_1 === -1) {
                return -1;
            }
            else {
                let matchValue_2_1;
                const s_9 = s_6;
                const i_8 = (i_5 + 2) | 0;
                if (i_8 >= s_9.length) {
                    matchValue_2_1 = -1;
                }
                else {
                    const c_4 = s_9[i_8];
                    matchValue_2_1 = (((c_4 > "9") ? true : (c_4 < "0")) ? -1 : (c_4.charCodeAt(0) - 48));
                }
                if (matchValue_2_1 === -1) {
                    return -1;
                }
                else {
                    let matchValue_3;
                    const s_10 = s_6;
                    const i_9 = (i_5 + 3) | 0;
                    if (i_9 >= s_10.length) {
                        matchValue_3 = -1;
                    }
                    else {
                        const c_5 = s_10[i_9];
                        matchValue_3 = (((c_5 > "9") ? true : (c_5 < "0")) ? -1 : (c_5.charCodeAt(0) - 48));
                    }
                    return ((matchValue_3 === -1) ? -1 : ((((matchValue_2 * 1000) + (matchValue_1_1 * 100)) + (matchValue_2_1 * 10)) + matchValue_3)) | 0;
                }
            }
        }
    }, s, start, 0, m, d);
}

function Internal_getString(bytes, index, len) {
    return get_UTF8().getString(bytes, index, len);
}

function Internal_parseDateTime_yyMMddHHmmss(ctor, asciiBytes) {
    let m_1, m_2, m_3, i, c, arg_1, i_1, c_1, arg_3, i_2, c_2, arg_5, i_3, c_3, arg_7, i_4, c_4, arg_9, i_5, c_5, arg_11, i_6, c_6, arg_13, i_7, c_7, arg_15, i_8, c_8, arg_17, i_9, c_9, arg_19, i_10, c_10, arg_21, i_11, c_11, arg_23;
    const m = Slice$1__get_Mark(asciiBytes);
    const ctx = Slice$1__get_Data(asciiBytes);
    if (((m_1 = m, equals(m_1, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_RightShift(m_1, 32)))))) !== 12) {
        const arg = Internal_getString(ctx, (m_2 = m, equals(m_2, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_BitwiseAnd(m_2, fromBits(4294967295, 0, false)))))), (m_3 = m, equals(m_3, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_RightShift(m_3, 32))))));
        toFail(printf("Expected datetime. Got : \u0027%s\u0027"))(arg);
    }
    const zero = 48;
    let p;
    const m_4 = m;
    p = (equals(m_4, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_BitwiseAnd(m_4, fromBits(4294967295, 0, false))))));
    const y = ((((i = 0, (c = (ctx[p + i] - zero), ((c > 9) ? true : (c < 0)) ? ((arg_1 = String.fromCharCode(c), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_1)(i))) : (~(~c))))) * 10) + ((i_1 = 1, (c_1 = (ctx[p + i_1] - zero), ((c_1 > 9) ? true : (c_1 < 0)) ? ((arg_3 = String.fromCharCode(c_1), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_3)(i_1))) : (~(~c_1)))))) | 0;
    return ctor((y > 80) ? (1900 + y) : (2000 + y), (((i_2 = 2, (c_2 = (ctx[p + i_2] - zero), ((c_2 > 9) ? true : (c_2 < 0)) ? ((arg_5 = String.fromCharCode(c_2), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_5)(i_2))) : (~(~c_2))))) * 10) + ((i_3 = 3, (c_3 = (ctx[p + i_3] - zero), ((c_3 > 9) ? true : (c_3 < 0)) ? ((arg_7 = String.fromCharCode(c_3), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_7)(i_3))) : (~(~c_3))))), (((i_4 = 4, (c_4 = (ctx[p + i_4] - zero), ((c_4 > 9) ? true : (c_4 < 0)) ? ((arg_9 = String.fromCharCode(c_4), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_9)(i_4))) : (~(~c_4))))) * 10) + ((i_5 = 5, (c_5 = (ctx[p + i_5] - zero), ((c_5 > 9) ? true : (c_5 < 0)) ? ((arg_11 = String.fromCharCode(c_5), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_11)(i_5))) : (~(~c_5))))), (((i_6 = 6, (c_6 = (ctx[p + i_6] - zero), ((c_6 > 9) ? true : (c_6 < 0)) ? ((arg_13 = String.fromCharCode(c_6), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_13)(i_6))) : (~(~c_6))))) * 10) + ((i_7 = 7, (c_7 = (ctx[p + i_7] - zero), ((c_7 > 9) ? true : (c_7 < 0)) ? ((arg_15 = String.fromCharCode(c_7), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_15)(i_7))) : (~(~c_7))))), (((i_8 = 8, (c_8 = (ctx[p + i_8] - zero), ((c_8 > 9) ? true : (c_8 < 0)) ? ((arg_17 = String.fromCharCode(c_8), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_17)(i_8))) : (~(~c_8))))) * 10) + ((i_9 = 9, (c_9 = (ctx[p + i_9] - zero), ((c_9 > 9) ? true : (c_9 < 0)) ? ((arg_19 = String.fromCharCode(c_9), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_19)(i_9))) : (~(~c_9))))), (((i_10 = 10, (c_10 = (ctx[p + i_10] - zero), ((c_10 > 9) ? true : (c_10 < 0)) ? ((arg_21 = String.fromCharCode(c_10), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_21)(i_10))) : (~(~c_10))))) * 10) + ((i_11 = 11, (c_11 = (ctx[p + i_11] - zero), ((c_11 > 9) ? true : (c_11 < 0)) ? ((arg_23 = String.fromCharCode(c_11), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_23)(i_11))) : (~(~c_11))))));
}

function Internal_parseDateTime_yyyyMMddHHmmss(ctor, asciiBytes) {
    let m_1, m_2, m_3, i, c, arg_1, i_1, c_1, arg_3, i_2, c_2, arg_5, i_3, c_3, arg_7, i_4, c_4, arg_9, i_5, c_5, arg_11, i_6, c_6, arg_13, i_7, c_7, arg_15, i_8, c_8, arg_17, i_9, c_9, arg_19, i_10, c_10, arg_21, i_11, c_11, arg_23, i_12, c_12, arg_25, i_13, c_13, arg_27;
    const m = Slice$1__get_Mark(asciiBytes);
    const ctx = Slice$1__get_Data(asciiBytes);
    if (((m_1 = m, equals(m_1, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_RightShift(m_1, 32)))))) !== 14) {
        const arg = Internal_getString(ctx, (m_2 = m, equals(m_2, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_BitwiseAnd(m_2, fromBits(4294967295, 0, false)))))), (m_3 = m, equals(m_3, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_RightShift(m_3, 32))))));
        toFail(printf("Expected datetime. Got : \u0027%s\u0027"))(arg);
    }
    const zero = 48;
    let p;
    const m_4 = m;
    p = (equals(m_4, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_BitwiseAnd(m_4, fromBits(4294967295, 0, false))))));
    return ctor((((((i = 0, (c = (ctx[p + i] - zero), ((c > 9) ? true : (c < 0)) ? ((arg_1 = String.fromCharCode(c), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_1)(i))) : (~(~c))))) * 1000) + (((i_1 = 1, (c_1 = (ctx[p + i_1] - zero), ((c_1 > 9) ? true : (c_1 < 0)) ? ((arg_3 = String.fromCharCode(c_1), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_3)(i_1))) : (~(~c_1))))) * 100)) + (((i_2 = 2, (c_2 = (ctx[p + i_2] - zero), ((c_2 > 9) ? true : (c_2 < 0)) ? ((arg_5 = String.fromCharCode(c_2), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_5)(i_2))) : (~(~c_2))))) * 10)) + ((i_3 = 3, (c_3 = (ctx[p + i_3] - zero), ((c_3 > 9) ? true : (c_3 < 0)) ? ((arg_7 = String.fromCharCode(c_3), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_7)(i_3))) : (~(~c_3))))), (((i_4 = 4, (c_4 = (ctx[p + i_4] - zero), ((c_4 > 9) ? true : (c_4 < 0)) ? ((arg_9 = String.fromCharCode(c_4), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_9)(i_4))) : (~(~c_4))))) * 10) + ((i_5 = 5, (c_5 = (ctx[p + i_5] - zero), ((c_5 > 9) ? true : (c_5 < 0)) ? ((arg_11 = String.fromCharCode(c_5), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_11)(i_5))) : (~(~c_5))))), (((i_6 = 6, (c_6 = (ctx[p + i_6] - zero), ((c_6 > 9) ? true : (c_6 < 0)) ? ((arg_13 = String.fromCharCode(c_6), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_13)(i_6))) : (~(~c_6))))) * 10) + ((i_7 = 7, (c_7 = (ctx[p + i_7] - zero), ((c_7 > 9) ? true : (c_7 < 0)) ? ((arg_15 = String.fromCharCode(c_7), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_15)(i_7))) : (~(~c_7))))), (((i_8 = 8, (c_8 = (ctx[p + i_8] - zero), ((c_8 > 9) ? true : (c_8 < 0)) ? ((arg_17 = String.fromCharCode(c_8), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_17)(i_8))) : (~(~c_8))))) * 10) + ((i_9 = 9, (c_9 = (ctx[p + i_9] - zero), ((c_9 > 9) ? true : (c_9 < 0)) ? ((arg_19 = String.fromCharCode(c_9), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_19)(i_9))) : (~(~c_9))))), (((i_10 = 10, (c_10 = (ctx[p + i_10] - zero), ((c_10 > 9) ? true : (c_10 < 0)) ? ((arg_21 = String.fromCharCode(c_10), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_21)(i_10))) : (~(~c_10))))) * 10) + ((i_11 = 11, (c_11 = (ctx[p + i_11] - zero), ((c_11 > 9) ? true : (c_11 < 0)) ? ((arg_23 = String.fromCharCode(c_11), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_23)(i_11))) : (~(~c_11))))), (((i_12 = 12, (c_12 = (ctx[p + i_12] - zero), ((c_12 > 9) ? true : (c_12 < 0)) ? ((arg_25 = String.fromCharCode(c_12), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_25)(i_12))) : (~(~c_12))))) * 10) + ((i_13 = 13, (c_13 = (ctx[p + i_13] - zero), ((c_13 > 9) ? true : (c_13 < 0)) ? ((arg_27 = String.fromCharCode(c_13), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_27)(i_13))) : (~(~c_13))))));
}

function Internal_parseDateTime_yyyy_MM_dd_HH_mm_ss(ctor, asciiBytes) {
    let m_1, m_2, m_3, i, c, arg_1, i_1, c_1, arg_3, i_2, c_2, arg_5, i_3, c_3, arg_7, i_4, c_4, arg_9, i_5, c_5, arg_11, i_6, c_6, arg_13, i_7, c_7, arg_15, i_8, c_8, arg_17, i_9, c_9, arg_19, i_10, c_10, arg_21, i_11, c_11, arg_23, i_12, c_12, arg_25, i_13, c_13, arg_27;
    const m = Slice$1__get_Mark(asciiBytes);
    const ctx = Slice$1__get_Data(asciiBytes);
    if (((m_1 = m, equals(m_1, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_RightShift(m_1, 32)))))) !== 19) {
        const arg = Internal_getString(ctx, (m_2 = m, equals(m_2, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_BitwiseAnd(m_2, fromBits(4294967295, 0, false)))))), (m_3 = m, equals(m_3, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_RightShift(m_3, 32))))));
        toFail(printf("Expected datetime. Got : \u0027%s\u0027"))(arg);
    }
    const zero = 48;
    let p;
    const m_4 = m;
    p = (equals(m_4, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_BitwiseAnd(m_4, fromBits(4294967295, 0, false))))));
    return ctor((((((i = 0, (c = (ctx[p + i] - zero), ((c > 9) ? true : (c < 0)) ? ((arg_1 = String.fromCharCode(c), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_1)(i))) : (~(~c))))) * 1000) + (((i_1 = 1, (c_1 = (ctx[p + i_1] - zero), ((c_1 > 9) ? true : (c_1 < 0)) ? ((arg_3 = String.fromCharCode(c_1), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_3)(i_1))) : (~(~c_1))))) * 100)) + (((i_2 = 2, (c_2 = (ctx[p + i_2] - zero), ((c_2 > 9) ? true : (c_2 < 0)) ? ((arg_5 = String.fromCharCode(c_2), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_5)(i_2))) : (~(~c_2))))) * 10)) + ((i_3 = 3, (c_3 = (ctx[p + i_3] - zero), ((c_3 > 9) ? true : (c_3 < 0)) ? ((arg_7 = String.fromCharCode(c_3), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_7)(i_3))) : (~(~c_3))))), (((i_4 = 5, (c_4 = (ctx[p + i_4] - zero), ((c_4 > 9) ? true : (c_4 < 0)) ? ((arg_9 = String.fromCharCode(c_4), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_9)(i_4))) : (~(~c_4))))) * 10) + ((i_5 = 6, (c_5 = (ctx[p + i_5] - zero), ((c_5 > 9) ? true : (c_5 < 0)) ? ((arg_11 = String.fromCharCode(c_5), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_11)(i_5))) : (~(~c_5))))), (((i_6 = 8, (c_6 = (ctx[p + i_6] - zero), ((c_6 > 9) ? true : (c_6 < 0)) ? ((arg_13 = String.fromCharCode(c_6), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_13)(i_6))) : (~(~c_6))))) * 10) + ((i_7 = 9, (c_7 = (ctx[p + i_7] - zero), ((c_7 > 9) ? true : (c_7 < 0)) ? ((arg_15 = String.fromCharCode(c_7), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_15)(i_7))) : (~(~c_7))))), (((i_8 = 11, (c_8 = (ctx[p + i_8] - zero), ((c_8 > 9) ? true : (c_8 < 0)) ? ((arg_17 = String.fromCharCode(c_8), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_17)(i_8))) : (~(~c_8))))) * 10) + ((i_9 = 12, (c_9 = (ctx[p + i_9] - zero), ((c_9 > 9) ? true : (c_9 < 0)) ? ((arg_19 = String.fromCharCode(c_9), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_19)(i_9))) : (~(~c_9))))), (((i_10 = 14, (c_10 = (ctx[p + i_10] - zero), ((c_10 > 9) ? true : (c_10 < 0)) ? ((arg_21 = String.fromCharCode(c_10), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_21)(i_10))) : (~(~c_10))))) * 10) + ((i_11 = 15, (c_11 = (ctx[p + i_11] - zero), ((c_11 > 9) ? true : (c_11 < 0)) ? ((arg_23 = String.fromCharCode(c_11), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_23)(i_11))) : (~(~c_11))))), (((i_12 = 17, (c_12 = (ctx[p + i_12] - zero), ((c_12 > 9) ? true : (c_12 < 0)) ? ((arg_25 = String.fromCharCode(c_12), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_25)(i_12))) : (~(~c_12))))) * 10) + ((i_13 = 18, (c_13 = (ctx[p + i_13] - zero), ((c_13 > 9) ? true : (c_13 < 0)) ? ((arg_27 = String.fromCharCode(c_13), toFail(printf("Illegal char \u0027%A\u0027 at %d."))(arg_27)(i_13))) : (~(~c_13))))));
}

export class InstantFormat {
    constructor(formatStr) {
        this.formatStr = formatStr;
    }
}

export function InstantFormat$reflection() {
    return class_type("Svea.Dry.Time.InstantFormat", void 0, InstantFormat);
}

export function InstantFormat_$ctor_Z721C83C5(formatStr) {
    return new InstantFormat(formatStr);
}

export function InstantFormat__get_formatString(x) {
    return x.formatStr;
}

export function InstantFormat_get_yyyy$002DMM$002DddTHH$003AmmZ() {
    return InstantFormat_$ctor_Z721C83C5("yyyy-MM-ddTHH:mmZ");
}

export function InstantFormat_get_yyyy$002DMM$002DddTHH$003Ammzzz() {
    return InstantFormat_$ctor_Z721C83C5("yyyy-MM-ddTHH:mmzzz");
}

export function InstantFormat_get_yyyy$002DMM$002DddTHH$003Amm$003AssZ() {
    return InstantFormat_$ctor_Z721C83C5("yyyy-MM-ddTHH:mm:ssZ");
}

export function InstantFormat_get_yyyy$002DMM$002DddTHH$003Amm$003Asszzz() {
    return InstantFormat_$ctor_Z721C83C5("yyyy-MM-ddTHH:mm:sszzz");
}

export function InstantFormat_get_yyyy$002DMM$002DddTHH$003Amm$003Ass_fffZ() {
    return InstantFormat_$ctor_Z721C83C5("yyyy-MM-ddTHH:mm:ss.fffZ");
}

export function InstantFormat_get_yyyy$002DMM$002DddTHH$003Amm$003Ass_fffzzz() {
    return InstantFormat_$ctor_Z721C83C5("yyyy-MM-ddTHH:mm:ss.fffzzz");
}

export function InstantFormat_Custom_Z721C83C5(formatStr) {
    return InstantFormat_$ctor_Z721C83C5(formatStr);
}

export class UTC {
    constructor(dt) {
        this.dt = dt;
        if (this.dt.kind !== 1) {
            const arg = this.dt.kind | 0;
            toFail(printf("DateTime must be DateTimeKind.Utc. Was %A"))(arg);
        }
    }
    Equals(o) {
        const x = this;
        return (o instanceof UTC) && equals(UTC__get_Ticks(x), UTC__get_Ticks(o));
    }
    GetHashCode() {
        const x = this;
        return fastStructuralHash(UTC__get_Ticks(x)) | 0;
    }
    toString() {
        const x = this;
        return toString(x.dt, "yyyy-MM-ddTHH:mm:ss.fffffffZ");
    }
    CompareTo(o) {
        const x = this;
        return ((o instanceof UTC) ? compare(UTC__get_Ticks(x), UTC__get_Ticks(o)) : -1) | 0;
    }
}

export function UTC$reflection() {
    return class_type("Svea.Dry.Time.UTC", void 0, UTC);
}

function UTC_$ctor_7F9DDECF(dt) {
    return new UTC(dt);
}

export function UTC__toDateTime(x) {
    return x.dt;
}

export function UTC__toDateTimeOffset(x) {
    return fromDate(x.dt);
}

export function UTC__get_Ticks(x) {
    return getTicks(x.dt);
}

export function UTC__get_Year(x) {
    return year_2(x.dt);
}

export function UTC__get_Month(x) {
    return month_2(x.dt);
}

export function UTC__get_Day(x) {
    return day_2(x.dt);
}

export function UTC__get_Hour(x) {
    return hour_2(x.dt);
}

export function UTC__get_Minute(x) {
    return minute_2(x.dt);
}

export function UTC__get_Second(x) {
    return second_2(x.dt);
}

export function UTC__get_Millisecond(x) {
    return millisecond(x.dt);
}

export function UTC_op_Addition_Z4B0C135B(t, ts) {
    return UTC_$ctor_7F9DDECF(op_Addition(UTC__toDateTime(t), ts));
}

export function UTC_op_Subtraction_368FF2C0(t, t$0027) {
    return op_Subtraction(UTC__toDateTime(t), UTC__toDateTime(t$0027));
}

export function UTC_ofDateTime_7F9DDECF(dt) {
    if (dt.kind !== 1) {
        return void 0;
    }
    else {
        return UTC_$ctor_7F9DDECF(dt);
    }
}

export function UTC_ofUtcDateTime_7F9DDECF(dt) {
    return UTC_$ctor_7F9DDECF(dt);
}

export function UTC_ofTicks_Z524259C1(utcTicks) {
    return UTC_$ctor_7F9DDECF(fromTicks(utcTicks, 1));
}

export function UTC_ofDateTimeOffset_Z53C0511E(dt) {
    return UTC_ofUtcDateTime_7F9DDECF(toUniversalTime(dt));
}

export function UTCModule_toDateTime(t) {
    return UTC__toDateTime(t);
}

export function UTCModule_toDateTimeOffset(t) {
    return UTC__toDateTimeOffset(t);
}

export function UTCModule_yyyy_MM_ddThh_mm_ss_fffZ(t) {
    let copyOfStruct = UTC__toDateTime(t);
    return toString(copyOfStruct, "yyyy-MM-ddThh:mm:ss.fffZ");
}

export function UTCModule_yyyy_MM_ddThh_mm_ssZ(t) {
    let copyOfStruct = UTC__toDateTime(t);
    return toString(copyOfStruct, "yyyy-MM-ddThh:mm:ssZ");
}

export function UTCModule_yyyy_MM_ddTHH_mm_ss_fffZ(t) {
    let copyOfStruct = UTC__toDateTime(t);
    return toString(copyOfStruct, "yyyy-MM-ddTHH:mm:ss.fffZ");
}

export function UTCModule_yyyy_MM_ddTHH_mm_ss_fffffffZ(t) {
    let copyOfStruct = UTC__toDateTime(t);
    return toString(copyOfStruct, "yyyy-MM-ddTHH:mm:ss.fffffffZ");
}

export function UTCModule_yyyy_MM_ddTHH_mm_ssZ(t) {
    let copyOfStruct = UTC__toDateTime(t);
    return toString(copyOfStruct, "yyyy-MM-ddTHH:mm:ssZ");
}

export function UTCModule_yyyy_MM_ddZ(t) {
    let copyOfStruct = UTC__toDateTime(t);
    return toString(copyOfStruct, "yyyy-MM-ddZ");
}

export function UTCModule_yyyy_MM_dd(t) {
    let copyOfStruct = UTC__toDateTime(t);
    return toString(copyOfStruct, "yyyy-MM-dd");
}

export function UTCModule_yy_MM_ddZ(t) {
    let copyOfStruct = UTC__toDateTime(t);
    return toString(copyOfStruct, "yy-MM-ddZ");
}

export function UTCModule_yy_MM_dd(t) {
    let copyOfStruct = UTC__toDateTime(t);
    return toString(copyOfStruct, "yy-MM-dd");
}

export function UTCModule_toStr(instantFormat, t) {
    let copyOfStruct = UTC__toDateTime(t);
    return toString(copyOfStruct, InstantFormat__get_formatString(instantFormat));
}

export function UTCModule_toIso8601Z(t) {
    return UTCModule_yyyy_MM_ddTHH_mm_ss_fffZ(t);
}

export function UTCModule_datetimeUtc(ticks, year, month, day, hour, minute, second, ms) {
    let dt$0027;
    return UTC_ofUtcDateTime_7F9DDECF((dt$0027 = create(year, month, day, hour, minute, second, ms, 1), equals(ticks, fromBits(0, 0, false)) ? dt$0027 : addMilliseconds(dt$0027, toNumber(op_Division(ticks, 10000)))));
}

export const UTCModule_datetimeMs = (() => {
    const ticks = fromBits(0, 0, false);
    return (year) => ((month) => ((day) => ((hour) => ((minute) => ((second) => ((ms) => UTCModule_datetimeUtc(ticks, year, month, day, hour, minute, second, ms)))))));
})();

export function UTCModule_datetimeTicks(year, month, day, hour, minute, second, ms, ticks) {
    return UTCModule_datetimeUtc(ticks, year, month, day, hour, minute, second, ms);
}

export function UTCModule_datetime(year, month, day, hour, minute, second) {
    return UTCModule_datetimeUtc(fromBits(0, 0, false), year, month, day, hour, minute, second, 0);
}

export function UTCModule_date(year, month, day) {
    return UTCModule_datetimeUtc(fromBits(0, 0, false), year, month, day, 0, 0, 0, 0);
}

export function UTCModule_addMilliseconds(n, t) {
    let copyOfStruct;
    return UTC_ofUtcDateTime_7F9DDECF((copyOfStruct = UTC__toDateTime(t), addMilliseconds(copyOfStruct, n)));
}

export function UTCModule_addSeconds(n, t) {
    let copyOfStruct;
    return UTC_ofUtcDateTime_7F9DDECF((copyOfStruct = UTC__toDateTime(t), addSeconds(copyOfStruct, n)));
}

export function UTCModule_addMinutes(n, t) {
    let copyOfStruct;
    return UTC_ofUtcDateTime_7F9DDECF((copyOfStruct = UTC__toDateTime(t), addMinutes(copyOfStruct, n)));
}

export function UTCModule_addHours(n, t) {
    let copyOfStruct;
    return UTC_ofUtcDateTime_7F9DDECF((copyOfStruct = UTC__toDateTime(t), addHours(copyOfStruct, n)));
}

export function UTCModule_addDays(n, t) {
    let copyOfStruct;
    return UTC_ofUtcDateTime_7F9DDECF((copyOfStruct = UTC__toDateTime(t), addDays(copyOfStruct, n)));
}

export function UTCModule_addMonths(n, t) {
    let copyOfStruct;
    return UTC_ofUtcDateTime_7F9DDECF((copyOfStruct = UTC__toDateTime(t), addMonths(copyOfStruct, n)));
}

export function UTCModule_addYears(n, t) {
    let copyOfStruct;
    return UTC_ofUtcDateTime_7F9DDECF((copyOfStruct = UTC__toDateTime(t), addYears(copyOfStruct, n)));
}

export function UTCModule_addTimeSpan(ts, t) {
    let copyOfStruct;
    return UTC_ofUtcDateTime_7F9DDECF((copyOfStruct = UTC__toDateTime(t), add(copyOfStruct, ts)));
}

function UTCModule_currentTime(f) {
    const dt = utcNow();
    return f(dt, UTCModule_datetimeMs(year_2(dt))(month_2(dt))(day_2(dt)));
}

export function UTCModule_currentMillisecond() {
    return UTCModule_currentTime((dt, ctor) => ctor(hour_2(dt))(minute_2(dt))(second_2(dt))(millisecond(dt)));
}

export function UTCModule_currentSecond() {
    return UTCModule_currentTime((dt, ctor) => ctor(hour_2(dt))(minute_2(dt))(second_2(dt))(0));
}

export function UTCModule_currentMinute() {
    return UTCModule_currentTime((dt, ctor) => ctor(hour_2(dt))(minute_2(dt))(0)(0));
}

export function UTCModule_currentHour() {
    return UTCModule_currentTime((dt, ctor) => ctor(hour_2(dt))(0)(0)(0));
}

export function UTCModule_today() {
    return UTCModule_currentTime((_arg, ctor) => ctor(0)(0)(0)(0));
}

export function UTCModule_now() {
    return UTC_ofUtcDateTime_7F9DDECF(utcNow());
}

export function UTCModule_Parse_yyyyMMdd(s) {
    return Internal_parseDate_yyyy(UTCModule_date, s, 0, 0, 4, 6);
}

export function UTCModule_Parse_yyyy_MM_dd(s) {
    return Internal_parseDate_yyyy(UTCModule_date, s, 0, 0, 5, 8);
}

export function UTCModule_Parse_http_date(s) {
    if (s.length === 29) {
        let day;
        const matchValue = substring(s, 0, 3);
        switch (matchValue) {
            case "Mon":
            case "Tue":
            case "Wed":
            case "Thu":
            case "Fri":
            case "Sat":
            case "Sun": {
                day = 0;
                break;
            }
            default: {
                day = -1;
            }
        }
        const comma = ((substring(s, 3, 2) === ", ") ? 0 : -1) | 0;
        let d;
        const s_1 = s;
        const i = 5;
        let matchValue_2;
        const s_2 = s_1;
        const i_1 = i | 0;
        if (i_1 >= s_2.length) {
            matchValue_2 = -1;
        }
        else {
            const c = s_2[i_1];
            matchValue_2 = (((c > "9") ? true : (c < "0")) ? -1 : (c.charCodeAt(0) - 48));
        }
        if (matchValue_2 === -1) {
            d = -1;
        }
        else {
            let matchValue_1_1;
            const s_3 = s_1;
            const i_2 = (i + 1) | 0;
            if (i_2 >= s_3.length) {
                matchValue_1_1 = -1;
            }
            else {
                const c_1 = s_3[i_2];
                matchValue_1_1 = (((c_1 > "9") ? true : (c_1 < "0")) ? -1 : (c_1.charCodeAt(0) - 48));
            }
            d = ((matchValue_1_1 === -1) ? -1 : ((matchValue_2 * 10) + matchValue_1_1));
        }
        let m;
        const matchValue_3 = substring(s, 8, 3);
        switch (matchValue_3) {
            case "Jan": {
                m = 1;
                break;
            }
            case "Feb": {
                m = 2;
                break;
            }
            case "Mar": {
                m = 3;
                break;
            }
            case "Apr": {
                m = 4;
                break;
            }
            case "May": {
                m = 5;
                break;
            }
            case "Jun": {
                m = 6;
                break;
            }
            case "Jul": {
                m = 7;
                break;
            }
            case "Aug": {
                m = 8;
                break;
            }
            case "Sep": {
                m = 9;
                break;
            }
            case "Oct": {
                m = 10;
                break;
            }
            case "Nov": {
                m = 11;
                break;
            }
            case "Dec": {
                m = 12;
                break;
            }
            default: {
                m = -1;
            }
        }
        let y;
        const s_4 = s;
        const i_3 = 12;
        let matchValue_4;
        const s_5 = s_4;
        const i_4 = i_3 | 0;
        if (i_4 >= s_5.length) {
            matchValue_4 = -1;
        }
        else {
            const c_2 = s_5[i_4];
            matchValue_4 = (((c_2 > "9") ? true : (c_2 < "0")) ? -1 : (c_2.charCodeAt(0) - 48));
        }
        if (matchValue_4 === -1) {
            y = -1;
        }
        else {
            let matchValue_1_2;
            const s_6 = s_4;
            const i_5 = (i_3 + 1) | 0;
            if (i_5 >= s_6.length) {
                matchValue_1_2 = -1;
            }
            else {
                const c_3 = s_6[i_5];
                matchValue_1_2 = (((c_3 > "9") ? true : (c_3 < "0")) ? -1 : (c_3.charCodeAt(0) - 48));
            }
            if (matchValue_1_2 === -1) {
                y = -1;
            }
            else {
                let matchValue_2_1;
                const s_7 = s_4;
                const i_6 = (i_3 + 2) | 0;
                if (i_6 >= s_7.length) {
                    matchValue_2_1 = -1;
                }
                else {
                    const c_4 = s_7[i_6];
                    matchValue_2_1 = (((c_4 > "9") ? true : (c_4 < "0")) ? -1 : (c_4.charCodeAt(0) - 48));
                }
                if (matchValue_2_1 === -1) {
                    y = -1;
                }
                else {
                    let matchValue_3_1;
                    const s_8 = s_4;
                    const i_7 = (i_3 + 3) | 0;
                    if (i_7 >= s_8.length) {
                        matchValue_3_1 = -1;
                    }
                    else {
                        const c_5 = s_8[i_7];
                        matchValue_3_1 = (((c_5 > "9") ? true : (c_5 < "0")) ? -1 : (c_5.charCodeAt(0) - 48));
                    }
                    y = ((matchValue_3_1 === -1) ? -1 : ((((matchValue_4 * 1000) + (matchValue_1_2 * 100)) + (matchValue_2_1 * 10)) + matchValue_3_1));
                }
            }
        }
        let hh;
        const s_9 = s;
        const i_8 = 17;
        let matchValue_5;
        const s_10 = s_9;
        const i_9 = i_8 | 0;
        if (i_9 >= s_10.length) {
            matchValue_5 = -1;
        }
        else {
            const c_6 = s_10[i_9];
            matchValue_5 = (((c_6 > "9") ? true : (c_6 < "0")) ? -1 : (c_6.charCodeAt(0) - 48));
        }
        if (matchValue_5 === -1) {
            hh = -1;
        }
        else {
            let matchValue_1_3;
            const s_11 = s_9;
            const i_10 = (i_8 + 1) | 0;
            if (i_10 >= s_11.length) {
                matchValue_1_3 = -1;
            }
            else {
                const c_7 = s_11[i_10];
                matchValue_1_3 = (((c_7 > "9") ? true : (c_7 < "0")) ? -1 : (c_7.charCodeAt(0) - 48));
            }
            hh = ((matchValue_1_3 === -1) ? -1 : ((matchValue_5 * 10) + matchValue_1_3));
        }
        let mm;
        const s_12 = s;
        const i_11 = 20;
        let matchValue_6;
        const s_13 = s_12;
        const i_12 = i_11 | 0;
        if (i_12 >= s_13.length) {
            matchValue_6 = -1;
        }
        else {
            const c_8 = s_13[i_12];
            matchValue_6 = (((c_8 > "9") ? true : (c_8 < "0")) ? -1 : (c_8.charCodeAt(0) - 48));
        }
        if (matchValue_6 === -1) {
            mm = -1;
        }
        else {
            let matchValue_1_4;
            const s_14 = s_12;
            const i_13 = (i_11 + 1) | 0;
            if (i_13 >= s_14.length) {
                matchValue_1_4 = -1;
            }
            else {
                const c_9 = s_14[i_13];
                matchValue_1_4 = (((c_9 > "9") ? true : (c_9 < "0")) ? -1 : (c_9.charCodeAt(0) - 48));
            }
            mm = ((matchValue_1_4 === -1) ? -1 : ((matchValue_6 * 10) + matchValue_1_4));
        }
        let ss;
        const s_15 = s;
        const i_14 = 23;
        let matchValue_7;
        const s_16 = s_15;
        const i_15 = i_14 | 0;
        if (i_15 >= s_16.length) {
            matchValue_7 = -1;
        }
        else {
            const c_10 = s_16[i_15];
            matchValue_7 = (((c_10 > "9") ? true : (c_10 < "0")) ? -1 : (c_10.charCodeAt(0) - 48));
        }
        if (matchValue_7 === -1) {
            ss = -1;
        }
        else {
            let matchValue_1_5;
            const s_17 = s_15;
            const i_16 = (i_14 + 1) | 0;
            if (i_16 >= s_17.length) {
                matchValue_1_5 = -1;
            }
            else {
                const c_11 = s_17[i_16];
                matchValue_1_5 = (((c_11 > "9") ? true : (c_11 < "0")) ? -1 : (c_11.charCodeAt(0) - 48));
            }
            ss = ((matchValue_1_5 === -1) ? -1 : ((matchValue_7 * 10) + matchValue_1_5));
        }
        if (((((((((day !== -1) && (comma !== -1)) && (d !== -1)) && (m !== -1)) && (y !== -1)) && (hh !== -1)) && (mm !== -1)) && (ss !== -1)) && (((substring(s, 25, 4) === " GMT") ? 0 : -1) !== -1)) {
            try {
                return UTCModule_datetime(y, m, d, hh, mm, ss);
            }
            catch (matchValue_9) {
                throw matchValue_9;
            }
        }
        else {
            return void 0;
        }
    }
    else {
        return void 0;
    }
}

export function UTCModule_Parse_iso8601Z(s) {
    let s_1, i, c, s_2, i_1, matchValue_2, s_3, i_2, c_1, matchValue_1_1, s_4, i_3, c_2, s_9, i_8, c_6, s_10, i_9, matchValue_5, s_11, i_10, c_7, matchValue_1_3, s_12, i_11, c_8, s_13, i_12, matchValue_6, s_14, i_13, c_9, matchValue_1_4, s_15, i_14, c_10, matchValue_2_2, s_16, i_15, c_11, n, n_1, n_2;
    try {
        const matchValue = s.length | 0;
        let pattern_matching_result, n_3;
        if (matchValue === 16) {
            if ((s[15] === "Z") && (s[8] === "T")) {
                pattern_matching_result = 0;
            }
            else if ((n = (matchValue | 0), ((((n >= 22) && (n <= 28)) && (s[n - 1] === "Z")) && (s[10] === "T")) && (s[19] === "."))) {
                pattern_matching_result = 2;
                n_3 = matchValue;
            }
            else {
                pattern_matching_result = 3;
            }
        }
        else if (matchValue === 20) {
            if ((s[19] === "Z") && (s[10] === "T")) {
                pattern_matching_result = 1;
            }
            else if ((n_1 = (matchValue | 0), ((((n_1 >= 22) && (n_1 <= 28)) && (s[n_1 - 1] === "Z")) && (s[10] === "T")) && (s[19] === "."))) {
                pattern_matching_result = 2;
                n_3 = matchValue;
            }
            else {
                pattern_matching_result = 3;
            }
        }
        else if ((n_2 = (matchValue | 0), ((((n_2 >= 22) && (n_2 <= 28)) && (s[n_2 - 1] === "Z")) && (s[10] === "T")) && (s[19] === "."))) {
            pattern_matching_result = 2;
            n_3 = matchValue;
        }
        else {
            pattern_matching_result = 3;
        }
        switch (pattern_matching_result) {
            case 0: {
                return Internal_parseDateTime_yyyy(UTCModule_datetime, s, 0, 4, 6, 9, 11, 13);
            }
            case 1: {
                return Internal_parseDateTime_yyyy(UTCModule_datetime, s, 0, 5, 8, 11, 14, 17);
            }
            case 2: {
                let _arg;
                const matchValue_1 = (n_3 - 22) | 0;
                switch (matchValue_1) {
                    case 0: {
                        _arg = (100 * ((s_1 = s, (i = 20, (i >= s_1.length) ? -1 : ((c = s_1[i], ((c > "9") ? true : (c < "0")) ? -1 : (c.charCodeAt(0) - 48)))))));
                        break;
                    }
                    case 1: {
                        _arg = (10 * ((s_2 = s, (i_1 = 20, (matchValue_2 = (((s_3 = s_2, (i_2 = (i_1 | 0), (i_2 >= s_3.length) ? -1 : ((c_1 = s_3[i_2], ((c_1 > "9") ? true : (c_1 < "0")) ? -1 : (c_1.charCodeAt(0) - 48)))))) | 0), (matchValue_2 === -1) ? -1 : ((matchValue_1_1 = (((s_4 = s_2, (i_3 = ((i_1 + 1) | 0), (i_3 >= s_4.length) ? -1 : ((c_2 = s_4[i_3], ((c_2 > "9") ? true : (c_2 < "0")) ? -1 : (c_2.charCodeAt(0) - 48)))))) | 0), (matchValue_1_1 === -1) ? -1 : ((matchValue_2 * 10) + matchValue_1_1))))))));
                        break;
                    }
                    default: {
                        const s_5 = s;
                        const i_4 = 20;
                        let matchValue_3;
                        const s_6 = s_5;
                        const i_5 = i_4 | 0;
                        if (i_5 >= s_6.length) {
                            matchValue_3 = -1;
                        }
                        else {
                            const c_3 = s_6[i_5];
                            matchValue_3 = (((c_3 > "9") ? true : (c_3 < "0")) ? -1 : (c_3.charCodeAt(0) - 48));
                        }
                        if (matchValue_3 === -1) {
                            _arg = -1;
                        }
                        else {
                            let matchValue_1_2;
                            const s_7 = s_5;
                            const i_6 = (i_4 + 1) | 0;
                            if (i_6 >= s_7.length) {
                                matchValue_1_2 = -1;
                            }
                            else {
                                const c_4 = s_7[i_6];
                                matchValue_1_2 = (((c_4 > "9") ? true : (c_4 < "0")) ? -1 : (c_4.charCodeAt(0) - 48));
                            }
                            if (matchValue_1_2 === -1) {
                                _arg = -1;
                            }
                            else {
                                let matchValue_2_1;
                                const s_8 = s_5;
                                const i_7 = (i_4 + 2) | 0;
                                if (i_7 >= s_8.length) {
                                    matchValue_2_1 = -1;
                                }
                                else {
                                    const c_5 = s_8[i_7];
                                    matchValue_2_1 = (((c_5 > "9") ? true : (c_5 < "0")) ? -1 : (c_5.charCodeAt(0) - 48));
                                }
                                _arg = ((matchValue_2_1 === -1) ? -1 : (((matchValue_3 * 100) + (matchValue_1_2 * 10)) + matchValue_2_1));
                            }
                        }
                    }
                }
                if (_arg === -1) {
                    return void 0;
                }
                else {
                    let _arg_1;
                    const matchValue_4 = (n_3 - 24) | 0;
                    if (matchValue_4 === 1) {
                        _arg_1 = (1000 * ((s_9 = s, (i_8 = 23, (i_8 >= s_9.length) ? -1 : ((c_6 = s_9[i_8], ((c_6 > "9") ? true : (c_6 < "0")) ? -1 : (c_6.charCodeAt(0) - 48)))))));
                    }
                    else if (matchValue_4 === 2) {
                        _arg_1 = (100 * ((s_10 = s, (i_9 = 23, (matchValue_5 = (((s_11 = s_10, (i_10 = (i_9 | 0), (i_10 >= s_11.length) ? -1 : ((c_7 = s_11[i_10], ((c_7 > "9") ? true : (c_7 < "0")) ? -1 : (c_7.charCodeAt(0) - 48)))))) | 0), (matchValue_5 === -1) ? -1 : ((matchValue_1_3 = (((s_12 = s_10, (i_11 = ((i_9 + 1) | 0), (i_11 >= s_12.length) ? -1 : ((c_8 = s_12[i_11], ((c_8 > "9") ? true : (c_8 < "0")) ? -1 : (c_8.charCodeAt(0) - 48)))))) | 0), (matchValue_1_3 === -1) ? -1 : ((matchValue_5 * 10) + matchValue_1_3))))))));
                    }
                    else if (matchValue_4 === 3) {
                        _arg_1 = (10 * ((s_13 = s, (i_12 = 23, (matchValue_6 = (((s_14 = s_13, (i_13 = (i_12 | 0), (i_13 >= s_14.length) ? -1 : ((c_9 = s_14[i_13], ((c_9 > "9") ? true : (c_9 < "0")) ? -1 : (c_9.charCodeAt(0) - 48)))))) | 0), (matchValue_6 === -1) ? -1 : ((matchValue_1_4 = (((s_15 = s_13, (i_14 = ((i_12 + 1) | 0), (i_14 >= s_15.length) ? -1 : ((c_10 = s_15[i_14], ((c_10 > "9") ? true : (c_10 < "0")) ? -1 : (c_10.charCodeAt(0) - 48)))))) | 0), (matchValue_1_4 === -1) ? -1 : ((matchValue_2_2 = (((s_16 = s_13, (i_15 = ((i_12 + 2) | 0), (i_15 >= s_16.length) ? -1 : ((c_11 = s_16[i_15], ((c_11 > "9") ? true : (c_11 < "0")) ? -1 : (c_11.charCodeAt(0) - 48)))))) | 0), (matchValue_2_2 === -1) ? -1 : (((matchValue_6 * 100) + (matchValue_1_4 * 10)) + matchValue_2_2))))))))));
                    }
                    else if (matchValue_4 === 4) {
                        const s_17 = s;
                        const i_16 = 23;
                        let matchValue_7;
                        const s_18 = s_17;
                        const i_17 = i_16 | 0;
                        if (i_17 >= s_18.length) {
                            matchValue_7 = -1;
                        }
                        else {
                            const c_12 = s_18[i_17];
                            matchValue_7 = (((c_12 > "9") ? true : (c_12 < "0")) ? -1 : (c_12.charCodeAt(0) - 48));
                        }
                        if (matchValue_7 === -1) {
                            _arg_1 = -1;
                        }
                        else {
                            let matchValue_1_5;
                            const s_19 = s_17;
                            const i_18 = (i_16 + 1) | 0;
                            if (i_18 >= s_19.length) {
                                matchValue_1_5 = -1;
                            }
                            else {
                                const c_13 = s_19[i_18];
                                matchValue_1_5 = (((c_13 > "9") ? true : (c_13 < "0")) ? -1 : (c_13.charCodeAt(0) - 48));
                            }
                            if (matchValue_1_5 === -1) {
                                _arg_1 = -1;
                            }
                            else {
                                let matchValue_2_3;
                                const s_20 = s_17;
                                const i_19 = (i_16 + 2) | 0;
                                if (i_19 >= s_20.length) {
                                    matchValue_2_3 = -1;
                                }
                                else {
                                    const c_14 = s_20[i_19];
                                    matchValue_2_3 = (((c_14 > "9") ? true : (c_14 < "0")) ? -1 : (c_14.charCodeAt(0) - 48));
                                }
                                if (matchValue_2_3 === -1) {
                                    _arg_1 = -1;
                                }
                                else {
                                    let matchValue_3_1;
                                    const s_21 = s_17;
                                    const i_20 = (i_16 + 3) | 0;
                                    if (i_20 >= s_21.length) {
                                        matchValue_3_1 = -1;
                                    }
                                    else {
                                        const c_15 = s_21[i_20];
                                        matchValue_3_1 = (((c_15 > "9") ? true : (c_15 < "0")) ? -1 : (c_15.charCodeAt(0) - 48));
                                    }
                                    _arg_1 = ((matchValue_3_1 === -1) ? -1 : ((((matchValue_7 * 1000) + (matchValue_1_5 * 100)) + (matchValue_2_3 * 10)) + matchValue_3_1));
                                }
                            }
                        }
                    }
                    else if (matchValue_4 <= 0) {
                        _arg_1 = 0;
                    }
                    else {
                        throw (new Error("impossible"));
                    }
                    return (_arg_1 === -1) ? (void 0) : Internal_parseDateTime_yyyy((y, mo, d, h, mi, s_22) => UTCModule_datetimeTicks(y, mo, d, h, mi, s_22, _arg, fromInteger(_arg_1, false, 2)), s, 0, 5, 8, 11, 14, 17);
                }
            }
            case 3: {
                return void 0;
            }
        }
    }
    catch (matchValue_8) {
        throw matchValue_8;
    }
}

export function UTCModule_Parse_yyMMddHHmmss(asciiBytes) {
    return Internal_parseDateTime_yyMMddHHmmss(UTCModule_datetime, asciiBytes);
}

export function UTCModule_Parse_yyyy_MM_dd_HH_mm_ss(asciiBytes) {
    return Internal_parseDateTime_yyyy_MM_dd_HH_mm_ss(UTCModule_datetime, asciiBytes);
}

export const UTCModule_$007CIso8601ZStr$007C_$007C = UTCModule_Parse_iso8601Z;

